// extracted by mini-css-extract-plugin
export var notificationHost = "_ed-0";